const { getZavarovalniskaStarostOsebe, getZacetekZavarovanja } = require("../../common");

/**
 * 
 * @param {Date} datumRojstva 
 * @param {string} paket 
 * @returns 
 */
function getPricesForPrvaDiagnoza(
    datumRojstva,
    paket,
) {

    const zavarovalniskaStarost
        = getZavarovalniskaStarostOsebe(
            getZacetekZavarovanja(),
            datumRojstva,
        );

    /**
     * @type {{ neto: number | null, davek: number | null, bruto: number | null }}
     */
    const prices = {
        neto: null,
        davek: null,
        bruto: null,
    }

    switch (paket) {
        case 'BrezNapotnice':
            
            if (zavarovalniskaStarost >= 15 && 
                    zavarovalniskaStarost <= 39) {
                prices.neto = 19.26;
                prices.davek = 1.64;
                prices.bruto = 20.90;
            }
            else if (zavarovalniskaStarost >= 40 && 
                    zavarovalniskaStarost <= 49) {
                prices.neto = 19.26;
                prices.davek = 1.64;
                prices.bruto = 20.90;
            }
            else if (zavarovalniskaStarost >= 50 && 
                    zavarovalniskaStarost <= 59) {
                prices.neto = 24.34;
                prices.davek = 2.07;
                prices.bruto = 26.41;
            }
            else if (zavarovalniskaStarost >= 60 && 
                    zavarovalniskaStarost <= 70) {
                prices.neto = 33.94;
                prices.davek = 2.88;
                prices.bruto = 36.82;
            }
            break;

        case 'BrezNapotnice+Rehabilitacije+OperativniPosegiZV10k':
            
            if (zavarovalniskaStarost >= 15 && 
                    zavarovalniskaStarost <= 39) {
                prices.neto = 25.24;
                prices.davek = 2.15;
                prices.bruto = 27.39;
            }
            else if (zavarovalniskaStarost >= 40 && 
                    zavarovalniskaStarost <= 49) {
                prices.neto = 27.04;
                prices.davek = 2.30;
                prices.bruto = 29.34;
            }
            else if (zavarovalniskaStarost >= 50 && 
                    zavarovalniskaStarost <= 59) {
                prices.neto = 32.84;
                prices.davek = 2.79;
                prices.bruto = 35.63;
            }
            else if (zavarovalniskaStarost >= 60 && 
                    zavarovalniskaStarost <= 70) {
                prices.neto = 39.72;
                prices.davek = 3.38;
                prices.bruto = 43.10;
            }
            break;

        case 'BrezNapotnice+Rehabilitacije+OperativniPosegiZV40k':
            
            if (zavarovalniskaStarost >= 15 && 
                    zavarovalniskaStarost <= 39) {
                prices.neto = 28.64;
                prices.davek = 2.43;
                prices.bruto = 31.07;
            }
            else if (zavarovalniskaStarost >= 40 && 
                    zavarovalniskaStarost <= 49) {
                prices.neto = 31.42;
                prices.davek = 2.67;
                prices.bruto = 34.09;
            }
            else if (zavarovalniskaStarost >= 50 && 
                    zavarovalniskaStarost <= 59) {
                prices.neto = 37.22;
                prices.davek = 3.16;
                prices.bruto = 40.38;
            }
            else if (zavarovalniskaStarost >= 60 && 
                    zavarovalniskaStarost <= 70) {
                prices.neto = 44.82;
                prices.davek = 3.81;
                prices.bruto = 48.63;
            }
            break;

        default:
            break;
    }

    return prices;
}

module.exports = { getPricesForPrvaDiagnoza };